import { useEffect, useState } from 'react';
import { Botao, Icone } from './ui/index.ts';

type Tema = 'escuro' | 'claro';
const CHAVE = 'teensibp:tema';

/**
 * O padrão é escuro por identidade — a parede preta do ministério —, não por
 * preferência do sistema. Por isso não consultamos prefers-color-scheme.
 */
export function useTema() {
  const [tema, setTema] = useState<Tema>(() => {
    try {
      return (localStorage.getItem(CHAVE) as Tema) ?? 'escuro';
    } catch {
      return 'escuro';
    }
  });

  useEffect(() => {
    document.documentElement.dataset.tema = tema;
    // Acompanha a barra do navegador no celular, senão fica um topo destoante.
    document
      .querySelector('meta[name="theme-color"]')
      ?.setAttribute('content', tema === 'escuro' ? '#0B0B0E' : '#FAFAF9');

    try {
      localStorage.setItem(CHAVE, tema);
    } catch {
      /* sem localStorage o tema só não persiste entre visitas */
    }
  }, [tema]);

  return { tema, alternar: () => setTema((t) => (t === 'escuro' ? 'claro' : 'escuro')) };
}

export function BotaoTema() {
  const { tema, alternar } = useTema();
  const proximo = tema === 'escuro' ? 'claro' : 'escuro';

  return (
    <Botao
      variante="fantasma"
      onClick={alternar}
      aria-label={`Mudar para o tema ${proximo}`}
      title={`Tema ${proximo}`}
      icone={tema === 'escuro' ? <Icone.Sol /> : <Icone.Lua />}
    />
  );
}
